/**
 * 接口域名管理
 */
const api = {
  url: 'https://con.guomall.com'
  // url: 'http://118.178.142.156:21011' // 测试
  // url: 'http://118.178.142.156:51005'
  // url: 'http://118.178.142.156:53011'
}
export default {
  api
}
